// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.login-flow-container {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
}

.login-modal {
    z-index: 2000 !important;
}

.login-verification-modal {
    z-index: 2001 !important;
}`, "",{"version":3,"sources":["webpack://./src/LoginFlow.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":["\n.login-flow-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: center;\n}\n\n.login-modal {\n    z-index: 2000 !important;\n}\n\n.login-verification-modal {\n    z-index: 2001 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
